<template>
  <div class="meterials-view">
    <article>
      <meterial ref="meterial"></meterial>
      <developer ref="developer"></developer>
    </article>
  </div>
</template>

<script>
import Meterial from './meterial'
import Developer from './developer'
export default {
  name: 'Meterials',
  inject: ['sourceData'],
  components: {
    Meterial,
    Developer
  },
  data () {
    return {

    }
  },
  methods: {
    validate () {
      return Promise.all([this.$refs.meterial.validate(), this.$refs.developer.validate()])
    }
  },
  created () {
  }
}
</script>

<style lang='less' scoped>
</style>
